<template>
  <div class="list-text">

        <div class="list-text__item" v-for="categories in list" :key="categories.id">
            <h1 class="lti__type">{{categories.type[$i18n.locale]}}</h1>

            <p class="lti__name" v-for="artist in categories.artists" :key="artist.id">
                <!-- <span @mouseleave="avatar.show=false" @mouseenter="mouseenter" @click="artistShow">{{ item.content[$i18n.locale].name }}</span> -->
                <span @mouseleave="avatar.show=false;avatar.img=null" @mouseenter="($event)=>mouseenter($event,artist)" @click="artistShow(artist)">{{ artist.content[$i18n.locale].name }}</span>
            </p>
        </div>
        <transition name="fade">
        <img class="list-avatar"  v-if="avatar.show && avatar.img" :style="{'left':avatar.offsetLeft+'px','top':avatar.offsetTop+'px'}" :src="avatar.img"/>
        </transition>
  </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
            default(){
                return []
            },
        },
        types:{
            type:Array,
            default(){
                return []
            },
        }
    },
    
    data(){
        return {
            avatar:{
                offsetLeft:0,
                offsetTop:0,
                show:false,
                img:'',
            }
        }
    },
    methods:{
        mouseenter(e,artist){
            let target= e.target.parentNode
            this.avatar.show=true
            this.avatar.offsetLeft=target.offsetLeft-180
            this.avatar.offsetTop=target.offsetTop-81
            this.avatar.img=artist.cover
        },
        artistShow(data){
            this.$emit('artist-show',data)
        }
    },
}
</script>

<style lang="less" scoped>
.list-text{
    column-count: 3;
    column-gap: 0;
    width: 1200px;
    margin: 0 auto 120px;

    .list-text__item{
        margin-bottom: 50px;
        break-inside: avoid;
        .lti__type{
            color: rgba(255, 255, 255, 0.6);
            font-size: 26px;
        }
        .lti__name{
            position: relative;
           
            margin-top: 42px;
            span{
                cursor: pointer;
                color: #fff;
                font-size: 18px;
                line-height: 18px;
                &:hover{
                    color: rgba(233, 84, 107, 1);
                }
            }
            
            
        }
    }

    .list-avatar{
        position: absolute;
        width: 162px;
        height: 162px;
        border-radius: 16px;
    }
}

@media screen and (max-width: 767px) {
    .list-text{
        column-count: 2;
        width: 95vw;
    }
    .lti__type{
        text-align: center;
        font-size: 6vw !important;
        margin-bottom: 8vw;
        font-weight: 700;
    }
    .lti__name{
        text-align: center;
        margin-bottom: 2vw;
        span{
            font-size: 4.6vw !important;
        line-height: 1.8 !important;
        
        }
        
    }

}
</style>